import { render } from "./CryptosCreep3d.vue?vue&type=template&id=82780f64&scoped=true"
import script from "./CryptosCreep3d.vue?vue&type=script&lang=js"
export * from "./CryptosCreep3d.vue?vue&type=script&lang=js"

import "./CryptosCreep3d.vue?vue&type=style&index=0&id=82780f64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82780f64"]])

export default __exports__